export default function Stepper(props: { stepNo: string; title: string }) {
  const { stepNo, title } = props;
  return (
    <p className="italic text-gray font-serif text-xl mt-12">
      Step {stepNo}: {title}
    </p>
  );
}
